import Vue from 'vue';

export const EVENTS = {
  IMAGE_SET_CHANGED: 'IMAGE_SET_CHANGED',
  ADD_TO_POOL: 'ADD_TO_POOL',
  POST_SKU_CANDIDATE: 'POST_SKU_CANDIDATE',
  POST_BULK_SKU_CANDIDATE: 'POST_BULK_SKU_CANDIDATE'
};

export default new Vue({
  data() {
    return {
      isSkuCandidateCreating: false,
      skuCandidateSize: 0
    };
  }
});
